/**
 * Installation test case sections for Signage / Signage team member.
 * Content matches the test cases documented in:
 * - InstallationCreate-TestCases.md
 * - InstallationView-TestCases.md
 * - InstallationEdit-TestCases.md
 */

export const INSTALLATION_CREATE_SECTIONS: {
  title: string;
  icon: string;
  items: { id: string; label: string }[];
}[] = [
  {
    title: "1. Pre-submit validation (UI)",
    icon: "ri-error-warning-line",
    items: [
      { id: "IC-V01", label: "User type required" },
      { id: "IC-V02", label: "Installer required" },
      { id: "IC-V03", label: "Email required" },
      { id: "IC-V04", label: "Phone required" },
      { id: "IC-V05", label: "Billing address required" },
      { id: "IC-V06", label: "Installation address when different" },
      { id: "IC-V07", label: "Scheduled date" },
      { id: "IC-V08", label: "Priority" },
      { id: "IC-V09", label: "Required special fees" },
      { id: "IC-V10", label: "Brokerage/office/team member when brokerageFirm" },
      { id: "IC-V11", label: "Agent when agent" },
    ],
  },
  {
    title: "2. User type and selection (UI)",
    icon: "ri-user-settings-line",
    items: [
      { id: "IC-U01", label: "Agent flow" },
      { id: "IC-U02", label: "Brokerage flow" },
      { id: "IC-U03", label: "Office agent (optional)" },
      { id: "IC-U04", label: "Cascade reset (brokerage)" },
      { id: "IC-U05", label: "Cascade reset (office)" },
    ],
  },
  {
    title: "3. Billing and installation address (UI)",
    icon: "ri-map-pin-line",
    items: [
      { id: "IC-A01", label: "Same as billing" },
      { id: "IC-A02", label: "Different addresses" },
      { id: "IC-A03", label: "Add address (AddAddressFormModal)" },
      { id: "IC-A04", label: "AddressAutocomplete for installation" },
      { id: "IC-A05", label: "Billing dropdown" },
    ],
  },
  {
    title: "4. Installer selection (UI)",
    icon: "ri-user-star-line",
    items: [
      { id: "IC-I01", label: "Select installer" },
      { id: "IC-I02", label: "Installer required" },
    ],
  },
  {
    title: "5. Scheduled date and priority (UI)",
    icon: "ri-calendar-check-line",
    items: [
      { id: "IC-D01", label: "Scheduled date" },
      { id: "IC-D02", label: "Priority" },
    ],
  },
  {
    title: "6. Post type and sign configuration (UI)",
    icon: "ri-layout-grid-line",
    items: [
      { id: "IC-P01", label: "PostTypeSignConfiguration" },
      { id: "IC-P02", label: "Post type required for submit" },
      { id: "IC-P03", label: "Product slots" },
    ],
  },
  {
    title: "7. Product selection (UI)",
    icon: "ri-shopping-cart-line",
    items: [
      { id: "IC-PR01", label: "Add product" },
      { id: "IC-PR02", label: "Remove product" },
      { id: "IC-PR03", label: "Duplicate product in slots" },
    ],
  },
  {
    title: "8. Special fees (UI)",
    icon: "ri-price-tag-3-line",
    items: [
      { id: "IC-S01", label: "InstallationandremovalSpecialfeeui load" },
      { id: "IC-S02", label: "Required fee" },
      { id: "IC-S03", label: "Select optional fee" },
      { id: "IC-S04", label: "Fee selection in payload" },
    ],
  },
  {
    title: "9. Tax (UI)",
    icon: "ri-calculator-line",
    items: [
      { id: "IC-T01", label: "INstallationandRemovalsTaxEngine" },
      { id: "IC-T02", label: "InstallationandRemovalTaxcloud" },
      { id: "IC-T03", label: "Tax on special fees" },
      { id: "IC-T04", label: "Tax address" },
    ],
  },
  {
    title: "10. Coupon / discount (UI)",
    icon: "ri-coupon-3-line",
    items: [
      { id: "IC-C01", label: "UnifiedInstallationCouponDiscount Apply" },
      { id: "IC-C02", label: "Eligibility" },
      { id: "IC-C03", label: "Clear discount" },
      { id: "IC-C04", label: "Existing discount on load" },
    ],
  },
  {
    title: "11. Notes (UI)",
    icon: "ri-file-text-line",
    items: [
      { id: "IC-N01", label: "InstructionsCreateCard (Notes)" },
      { id: "IC-N02", label: "Notes display" },
    ],
  },
  {
    title: "12. Submit and payload (API)",
    icon: "ri-send-plane-line",
    items: [
      { id: "IC-X01", label: "Successful create" },
      { id: "IC-X02", label: "Payload structure" },
      { id: "IC-X03", label: "Submit error" },
      { id: "IC-X04", label: "Image upload" },
    ],
  },
  {
    title: "13. UI display and route",
    icon: "ri-route-line",
    items: [
      { id: "IC-R01", label: "Route Signage" },
      { id: "IC-R02", label: "Route Signage team member" },
      { id: "IC-R03", label: "InstallationStatusTracker" },
      { id: "IC-R04", label: "Save button state" },
    ],
  },
];

export const INSTALLATION_VIEW_SECTIONS: {
  title: string;
  icon: string;
  items: { id: string; label: string }[];
}[] = [
  {
    title: "1. Load and display (UI)",
    icon: "ri-eye-line",
    items: [
      { id: "IV-D01", label: "Load installation by ID" },
      { id: "IV-D02", label: "Display billing address" },
      { id: "IV-D03", label: "Display installation address" },
      { id: "IV-D04", label: "Display installer" },
      { id: "IV-D05", label: "Display scheduled date and priority" },
      { id: "IV-D06", label: "Display post type and sign config" },
      { id: "IV-D07", label: "Display products / line items" },
      { id: "IV-D08", label: "Display special fees" },
      { id: "IV-D09", label: "Display tax" },
      { id: "IV-D10", label: "Display coupon / discount" },
      { id: "IV-D11", label: "Display notes" },
      { id: "IV-D12", label: "404 / not found" },
    ],
  },
  {
    title: "2. InstallationStatusTracker (UI)",
    icon: "ri-flow-chart",
    items: [
      { id: "IV-S01", label: "Draft (0)" },
      { id: "IV-S02", label: "Payment (150)" },
      { id: "IV-S03", label: "Finalized" },
      { id: "IV-S04", label: "Scheduled" },
      { id: "IV-S05", label: "In Progress" },
      { id: "IV-S06", label: "Completed" },
      { id: "IV-S07", label: "Cancelled" },
      { id: "IV-S08", label: "Removal: Closed / Void" },
    ],
  },
  {
    title: "3. Actions and navigation (UI)",
    icon: "ri-links-line",
    items: [
      { id: "IV-A01", label: "Edit link" },
      { id: "IV-A02", label: "Edit disabled" },
      { id: "IV-A03", label: "Back to list" },
      { id: "IV-A04", label: "Route Signage" },
      { id: "IV-A05", label: "Route Signage team member" },
    ],
  },
];

export const INSTALLATION_EDIT_SECTIONS: {
  title: string;
  icon: string;
  items: { id: string; label: string }[];
}[] = [
  {
    title: "1. Load and hydration (UI)",
    icon: "ri-download-cloud-line",
    items: [
      { id: "IE-L01", label: "Load installation for edit" },
      { id: "IE-L02", label: "Hydrate addresses" },
      { id: "IE-L03", label: "Hydrate special fees" },
      { id: "IE-L04", label: "Hydrate tax and coupon" },
      { id: "IE-L05", label: "404 / not found" },
    ],
  },
  {
    title: "2. Editable vs read-only by status (UI)",
    icon: "ri-lock-line",
    items: [
      { id: "IE-E01", label: "Draft editable" },
      { id: "IE-E02", label: "Post-payment read-only fields" },
      { id: "IE-E03", label: "Cancelled" },
      { id: "IE-E04", label: "InstallationStatusTracker on edit" },
    ],
  },
  {
    title: "3. Address updates (UI)",
    icon: "ri-map-pin-line",
    items: [
      { id: "IE-A01", label: "Change billing address" },
      { id: "IE-A02", label: "Toggle same-as-billing" },
      { id: "IE-A03", label: "Add new address (AddAddressFormModal)" },
      { id: "IE-A04", label: "AddressAutocomplete for installation" },
    ],
  },
  {
    title: "4. Post type and products (UI)",
    icon: "ri-layout-grid-line",
    items: [
      { id: "IE-P01", label: "Change post type / sign config" },
      { id: "IE-P02", label: "Add/remove products" },
    ],
  },
  {
    title: "5. Notes and special fees (UI)",
    icon: "ri-file-text-line",
    items: [
      { id: "IE-N01", label: "Update notes" },
      { id: "IE-N02", label: "Change special fees" },
      { id: "IE-N03", label: "Required special fees on edit" },
    ],
  },
  {
    title: "6. Tax and coupon on edit (UI)",
    icon: "ri-calculator-line",
    items: [
      { id: "IE-T01", label: "Tax recalc on edit" },
      { id: "IE-T02", label: "TaxCloud on save" },
      { id: "IE-T03", label: "Change coupon" },
      { id: "IE-T04", label: "Existing discount display" },
    ],
  },
  {
    title: "7. Save and payload (API)",
    icon: "ri-send-plane-line",
    items: [
      { id: "IE-X01", label: "Successful save" },
      { id: "IE-X02", label: "Payload structure" },
      { id: "IE-X03", label: "Save error" },
      { id: "IE-X04", label: "Validation on save" },
    ],
  },
];
